<template>
    <div class="birthday-item text-center">
        <img :src="image" class="img-birth" alt="">
        <p class="text-bold">{{ name}}</p>
    </div>
</template>
<script>
export default {
    name: 'BirthdayItem',
    props: ['image','name']
}
</script>
<style>
.img-birth{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Birthday/BirthdayItem.vue